import { render } from "./Tasas.vue?vue&type=template&id=2b92128e"
import script from "./Tasas.vue?vue&type=script&lang=js"
export * from "./Tasas.vue?vue&type=script&lang=js"

import "./Tasas.vue?vue&type=style&index=0&id=2b92128e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__